import clsx from 'clsx';
import BottomBar from './BottomBar.jsx';

function BottomBarArea({ sticky = true, children }) {
  return (
    <div className={clsx(sticky && 'sticky-bottom')}>
      {children}
    </div>
  );
}

export default BottomBarArea;
